import React from 'react';
import TemplateModal from './TemplateModal';
import type { DocumentFormat } from '../../../hooks/deals/usePDFGeneration';
import type { QuoteLine } from './QuoteLinesPicker';

interface TemplateModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  templates: any[];
  unsuitableTemplates?: any[];
  allowUnsuitable?: boolean;
  selectedTemplateId?: string;
  setSelectedTemplateId?: React.Dispatch<React.SetStateAction<string>>;
  onGenerateDocument?: (format: DocumentFormat, serviceIds?: string[]) => Promise<void>;
  services?: QuoteLine[];
  /** @deprecated Use onGenerateDocument instead */
  onGeneratePDF?: () => Promise<void>;
  onGenerateSignatureLink?: () => Promise<void>;
  generatingPdf?: boolean;
  generatingSignatureLink?: boolean;
  debugMode?: boolean;
  translations?: any;
}

export const TemplateModalWrapper: React.FC<TemplateModalWrapperProps> = (props) => {
  // Semplicemente passa tutti i props al componente TemplateModal 
  return (
    <TemplateModal
      {...props}
    />
  );
};

export default TemplateModalWrapper;